<template>
  <v-lazy>
    <div>
      <v-divider v-if="index>0" class="my-4"></v-divider>
      <div
        :class="{
          'd-flex align-center': true,
          'flex-row': !mobile,
          'flex-column': mobile
        }"
      >
        <v-img
          :aspect-ratio="16/9"
          :width="mobile ? '100vw' : '400px'"
          :src="article.banner"
          contain
        ></v-img>
        <div :class="{ 'ml-4': !mobile }">
          <router-link :to="{ name: 'Article', params: { id: article._id } }">
            <v-card-title
              class="font-weight-black primary--text"
            >
              {{ article.title }}
            </v-card-title>
          </router-link>
          <v-divider></v-divider>
          <v-card-text style="word-break: break-all;">
            {{ trixText }}......
          </v-card-text>
          <v-card-actions class="px-4">
            <v-chip small>{{ article.type }}</v-chip>
            <v-chip small class="ml-2">{{ article.cat }}</v-chip>
            <v-spacer></v-spacer>
            <v-btn
              text
              large
              color="primary"
              aria-label="繼續閱讀"
              class="font-weight-black pl-4"
              :to="{ name: 'Article', params: { id: article._id } }"
            >
              繼續閱讀<v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-card-actions>
        </div>
      </div>
    </div>
  </v-lazy>
</template>

<script>
export default {
  props: ['article', 'index'],
  computed: {
    mobile() {
      return this.$store.state.mobile;
    },
    trixText() {
      const num = this.mobile ? 100 : 100;
      return this.stripHtml(this.article.trixText, num);
    },
  },
  methods: {
    stripHtml(html, num) {
      const str = html || ''
      const newstr = str.replace('<br>', '。') 
      const tmp = document.createElement('div');
      tmp.innerHTML = newstr;
      const res = tmp.textContent || tmp.innerText || '';
      return res.trim().slice(0, num);
    }
  }
}
</script>